import { Popover, Upload } from "antd";
import Axios from "axios";
import React, { useMemo, useState } from "react";
import { useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import errorHandler from "../../helpers/ErrorHandler";
import { antdMessageError, antdMessageSuccess } from "../../helpers/Utils";
import { DebounceSelect } from "../common";
import { ClearFilterButton, SearchButton } from "../common/Buttons";
import TextInputModal from "../common/TextInputModal";
import { IconExpand, IconImport } from "../Layout/Icons";

export default function AutosysSku({
  type = 'autosys',
  title = 'SKU',
  products = [],
  setValue,
  warning,
}) {
  useEffect(() => {
    // hacking with dom elements
    const node = document.querySelector(".select_with_hidden_items");
    if (!node) return;
    const items = node.querySelectorAll(".ant-select-selection-item");
    if (items.length < 15)
      return items.forEach((d) => (d.style.display = "flex"));
    items.forEach((d) => (d.style.display = "none"));
    [...items]
      .slice(items.length - 15, items.length)
      .forEach((d) => (d.style.display = "flex"));
  }, [products.length]);
  const [open, setOpen] = useState(false);

  const onChange = (info) => {
    if (info?.file?.status == "uploading") return;
    if (info?.file?.response && info?.file?.status !== "error") {
      antdMessageSuccess("Import successful");
      setValue((prev) => ({
        ...prev,
        [`${type}_products`]: [
          ...prev[`${type}_products`],
          ...info.file.response.skus
            .filter((d) => d)
            .map((d) => ({
              id: null,
              sku: d,
              imported: true,
            })),
        ],
      }));
    } else {
      antdMessageError();
    }
  };
  const beforeUpload = (file) => {
    console.log(file);
    const isExcel =
      file.type.includes("application") && file.name.split(".")[1] === "xlsx";
    if (!isExcel) {
      antdMessageError("The file must be in .xlsx format!");
    }

    return isExcel;
  };

  let file_props = {
    name: "file",
    action: "/api/v1/autosys/sku_document",
    showUploadList: false,
    beforeUpload: beforeUpload,
    onChange: onChange,
  };

  const fetchOptions = async (value) => {
    try {
      const { data } = await Axios.get(
        `/api/v1/products/simple_products.json?q[identifier_eq]=${value}`
      );
      return (
        data?.data
          ?.map((e) => ({
            sku: e.identifier,
            value: e.identifier,
            label: `${e.identifier} - ${e.title}`,
          }))
          .filter((d) => !products.find((s) => s.sku == d.sku)) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  const onRemove = (val) => {
    const make_arr = products
      .map((d) => {
        if (d.sku == val) {
          if (d.id) return { ...d, _destroy: true };
          return { ...d, local_delete: true };
        }
        return d;
      })
      .filter((d) => !d.local_delete);
    setValue((prev) => ({
      ...prev,
      [`${type}_products`]: make_arr,
    }));
  };

  const arr = products
    .map((d) => ({
      ...d,
      label: d.label || d.sku,
      value: d.value || d.sku,
    })).filter((d) => !d._destroy);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div
          className={`editLabelForm text-bold my-1 ${warning && "text-danger"}`}
        >
          {title}
        </div>
        <div>
          <IconExpand onClick={() => setOpen(true)} />
        </div>
      </div>
      <Popover
        placement="left"
        title={
          <div className="d-flex align-items-center justify-content-between py-2">
            <div className="font-semi-bold text-base text-black">SKU</div>
            <div>{products?.length} SKU in the list</div>
            <AiOutlineClose
              className="cursor-pointer text-black"
              onClick={() => setOpen(false)}
            />
          </div>
        }
        content={
          open ? (
            <PopoverModal
              products={arr}
              remove={true}
              onRemove={onRemove}
            />
          ) : (
            ""
          )
        }
        trigger="click"
        visible={open || false}
      >
        <div
          style={{
            border: products.length > 15 ? "1px solid #d9d9d9" : "none",
          }}
        >
          <DebounceSelect
            className={`select_with_hidden_items ${products.length > 15 ? 'antd-select-hidden-border' : ''}`}
            mode="multiple"
            style={{
              filter: open ? "blur(3px)" : "none",
              width: "100%",
            }}
            value={arr}
            placeholder="Type in"
            fetchOptions={fetchOptions}
            onChange={(newValue, test, test2) => {
              console.log({ newValue, test, test2 });
              // mums senus reikia priskirt _destroy: 1,
              const make_arr = newValue.map((d) => {
                const find = products.find((e) => e.sku == d.value);
                if (find) return find;
                return {
                  id: null,
                  [`${type == 'energy' ? 'energy_label' : type}_id`]: null,
                  sku: d.value,
                };
              });
              if (
                products.filter((d) => d.id).length !==
                newValue.filter((d) => d.id).length
              ) {
                products
                  .filter((d) => d.id)
                  .filter((d) => !make_arr.find((s) => s.id == d.id))
                  .forEach((d) => {
                    make_arr.push({ ...d, _destroy: true });
                  });
              }

              setValue((prev) => ({
                ...prev,
                [`${type}_products`]: make_arr,
              }));
            }}
          />
          {products.length > 15 && (
            <div>
              <div
                className="d-flex align-items-center justify-content-center cursor-pointer text-primary pt-3 pb-2"
                onClick={() => setOpen(true)}
              >
                <IconExpand className="text-xl text-primary mr-2" />
                Click here to expand view
              </div>
            </div>
          )}
        </div>
      </Popover>
      {warning && <div className="text-danger">{warning}</div>}

      <Upload {...file_props} className="mr-3">
        <p className="mt-2 text-center text-primary text-sm">
          <IconImport />
          Import XSLX
        </p>
      </Upload>
    </>
  );
}

export const PopoverModal = ({
  products,
  remove = false,
  onRemove,
}) => {
  const [searchVal, setSearchVal] = useState("");
  const [active, setActive] = useState(false);
  console.log({filtered, products})
  const filtered = useMemo(() => {
    if (!searchVal) return products;
    console.log({ products });
    return products.filter(
      (d) =>
        d.value.toString().toUpperCase().indexOf(searchVal.toUpperCase()) > -1
    );
  }, [active]);

  return (
    <div
      style={{
        minwidth: 525,
      }}
    >
      <div className="d-flex align-items-center mb-2">
        <div className="flex-1">
          <TextInputModal
            style={{
              width: "100%",
            }}
            placeholder="SKU"
            value={searchVal}
            onChange={(e) => {
              const val = e.target.value;
              setSearchVal(val);
            }}
          />
        </div>
        <SearchButton
          className={"mx-2"}
          onClick={() => setActive((prev) => !prev)}
        />
        <ClearFilterButton
          onClick={() => {
            setSearchVal("");
            setActive((prev) => !prev);
          }}
        />
      </div>

      <div
        style={{
          border: "1px solid #F2F2F2",
          borderRadius: "4px 2px 2px 4px",
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gap: 5,
          padding: "5px 4px",
        }}
      >
        {filtered.map((d, idx) => (
          <div
            key={`${d?.value}_${idx}`}
            className="d-flex align-items-center justify-content-center cursor-pointer"
            style={{
              backgroundColor: "#F5F5F5",
              borderRadius: 2,
              padding: "4px 5px 4px 6px",
            }}
            onClick={
              remove
                ? () => {
                  onRemove(d.value);

                  setActive((prev) => !prev);
                }
                : () => console.log("Remove handler")
            }
          >
            {d?.value}
            {remove && <AiOutlineClose />}
          </div>
        ))}
      </div>
    </div>
  );
};
